import React from 'react';
import { Html, useProgress } from '@react-three/drei';

// Basic CSS for spinner directly in the component for simplicity
const spinnerStyle = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .loader-spinner {
    border: 4px solid rgba(255, 255, 255, 0.2);
    border-left-color: #ffffff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
`;

function Loader() {
  const { progress } = useProgress(); // Drei hook to get loading progress

  return (
    // Html component renders HTML inside the WebGL canvas
    <Html center>
      <style>{spinnerStyle}</style>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontFamily: 'sans-serif'
      }}>
        <div className="loader-spinner"></div>
        <p style={{ marginTop: '15px', fontSize: '14px' }}>
           {progress.toFixed(1)}% loaded
        </p>
        {/* <p style={{ marginTop: '5px', fontSize: '12px' }}>Loading Experience...</p> */}
      </div>
    </Html>
  );
}

export default Loader; 